/**
 * Consultant-related functionality for project forms
 */

export function setupConsultantLinks() {
    // Remove any existing consultant links first to prevent duplicates
    document.querySelectorAll('.consultant-link-container').forEach(container => container.remove());
    
    let consultantSelects = document.querySelectorAll('select[name*="consultant_formset"][name$="-consultant"]');
    
    if (consultantSelects.length === 0) {
        consultantSelects = document.querySelectorAll('select[name*="consultant"]:not([name*="currency"]):not([name*="rate"])');
    }
    
    if (consultantSelects.length === 0) {
        const consultantFieldset = document.querySelector('fieldset legend');
        if (consultantFieldset && consultantFieldset.textContent.includes('Consultants')) {
            const allSelects = consultantFieldset.parentElement.querySelectorAll('select');
            consultantSelects = Array.from(allSelects).filter(select => 
                !select.name.includes('currency') && !select.name.includes('rate')
            );
        }
    }
    
    consultantSelects.forEach((select) => {
        // Skip if already setup
        if (select.consultantLinkSetup) return;
        
        const cell = select.closest('td');
        if (!cell) return;
        
        // Create a small, inline link container
        const linkContainer = document.createElement('span');
        linkContainer.className = 'consultant-link-container';
        linkContainer.style.marginLeft = '8px';
        linkContainer.style.whiteSpace = 'nowrap';
        
        select.parentNode.insertBefore(linkContainer, select.nextSibling);
        
        function updateConsultantLink() {
            const selectedValue = select.value;
            linkContainer.innerHTML = '';
            
            if (selectedValue && selectedValue !== '' && selectedValue !== '--------') {
                const link = document.createElement('a');
                link.href = `/hr/profiles/${selectedValue}/`;
                link.target = '_blank';
                link.textContent = '👤';
                link.title = 'View Consultant Profile';
                link.style.fontSize = '0.9rem';
                link.style.color = '#4ba8ae';
                link.style.textDecoration = 'none';
                link.style.marginLeft = '5px';
                link.addEventListener('mouseenter', () => {
                    link.style.transform = 'scale(1.2)';
                    link.style.transition = 'transform 0.2s';
                });
                link.addEventListener('mouseleave', () => {
                    link.style.transform = 'scale(1)';
                });
                
                linkContainer.appendChild(link);
            }
        }
        
        select.addEventListener('change', updateConsultantLink);
        select.addEventListener('input', updateConsultantLink);
        
        setTimeout(updateConsultantLink, 100);
        
        select.consultantLinkSetup = true;
    });
}